"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nService = void 0;
var i18n_1 = require("@unitedtraders/i18n");
var mobx_1 = require("mobx");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var I18nService = /** @class */ (function () {
    function I18nService(lng, changeLng, options) {
        var _this = this;
        this.changeLng = changeLng;
        this.lngSubject = new rxjs_1.Subject();
        this.onChangeLng = function (lng) {
            _this.lng = lng;
            _this.lngSubject.next(lng);
            _this.i18next.changeLanguage(lng);
        };
        this.lng = lng;
        this.i18next = i18n_1.createInstance(options.modules, lng);
        this.i18next.init(__assign(__assign({}, options.i18nextOptions), { resources: options.i18nextOptions.resources }));
        mobx_1.makeObservable(this);
        this.lngObservable = rxjs_1.concat(new rxjs_1.Observable(function (observer) {
            if (_this.lng)
                observer.next(_this.lng);
            observer.complete();
        }), this.lngSubject).pipe(operators_1.shareReplay(1), operators_1.distinctUntilChanged());
    }
    I18nService.prototype.addResourceBundle = function (resource) {
        var _this = this;
        Object.keys(resource).forEach(function (lng) {
            Object.keys(resource[lng]).forEach(function (ns) {
                _this.i18next.addResourceBundle(lng, ns, resource[lng][ns], true, true);
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], I18nService.prototype, "lng", void 0);
    __decorate([
        mobx_1.action
    ], I18nService.prototype, "onChangeLng", void 0);
    return I18nService;
}());
exports.I18nService = I18nService;
